<template>
  <div>
    <CRow>
      <CCol xs="12" lg="12">
        <CCard>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>Direct Candidate View</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <div class="detail-div">
              <CRow>
                <CCol sm="6" md="4" lg="4">
                  <img :src="detail.avatar" />
                  <br>
                  <br>
                  <p><span class="custome-labal">Name :</span> <span>{{ detail.firstName }}{{ detail.lastName }}</span></p>
                  <p><span class="custome-labal">Email :</span> <span>{{ detail.email }}</span></p>
                  <p><span class="custome-labal">Title :</span> <span>{{ detail.title }}</span></p>
                  <p><span class="custome-labal">Address :</span> <span>{{ detail.address }}</span></p>
                  <p><span class="custome-labal">Mobile Number :</span> <span>{{ detail.countryCode }} {{detail.mobileNo}}</span></p>
                  <p>
                    <span class="custome-labal">Status :</span>
                    <span v-if="detail.active == 1">Active</span>
                    <span v-else>Deactive</span>
                  </p>
                  <p><span class="custome-labal">AI Resume :</span> <span>{{detail.ai}}</span></p>
                  <p><span class="custome-labal">Manual Resume :</span> <span>{{detail.manual}}</span></p>
                </CCol>
              </CRow>
            </div>

            
              <CForm @submit.prevent="onProfileSubmit">
                
                  <h4>Menu</h4>
                  <table class="table table-bordered">
                    <tr>
                      <th>Sequence</th>
                      <th>Module</th>
                      <th>Permission</th>
                      <th>Action</th>
                    </tr>
                    
                      <tr v-for="(bottom,index) in bottomMenuList">
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td>
                          <v-select :id="bottom.id" v-model="bottom.selected"
                                    @input="changePermission(index,bottom.selected)"
                                    :options="bottomMenuOptions"></v-select>
                        </td>
                        <td>
                          <v-select :id="bottom.id" v-model="bottom.permission" :options="bottom.permissionList"
                                    multiple></v-select>
                        </td>
                        <td>
                          <button type="button" class="btn btn-success" @click="addMenu">
                            <i class="fa fa-plus"></i>
                          </button>&nbsp;
                        </td>
                      </tr>
                  </table>
                <CCol col="2" class="text-left">
                  <CButton color="primary" :disabled="submitted" class="px-4" type="submit">
                    {{ $lang.common.general.submit }}
                  </CButton>
                </CCol>
              </CForm>

          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {DirectCandidates} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";

Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);
export default {
  name: "DirectCandidateView",
  mixins: [Mixin],
  data() {
    return {
      counter: 0,
      inputs: [],
      bottomMenuOptions: [],
      bottomMenuList: [{
        id: '0',
        selected: '',
        permission: [],
        permissionList: []
      }],
      exampleData: [],
      messageColor: "",
      submitted: false,
      SubmitBtn: "Submit",
      err_msg: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      self: this,
      moduleCountry: DirectCandidates,
      detail : {}
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    self.dismissCountDown = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
    self.editId = this.$route.params.id;
    axios.get('direct-candidates/view/'+self.editId)
      .then((response) => {
        self.detail = response.data.data;
        var responseData = response.data.data;
        self.bottomMenuList = responseData.bottomMenuList;
        store.commit("showLoader", false);
      })
      .catch(function () {
        store.commit("showLoader", false);
      });
      axios.get('/plan/permission/lists/DirectCandidate').then((response) => {
        response.data.data.map(function (value, key) {
          self.bottomMenuOptions.push({value: value.id, label: value.title});
        });
      });
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    onProfileSubmit() {
      let self = this;
      self.submitted = true; //Disable Button
      this.submitStatus = "PENDING";
      setTimeout(() => {
        const postData = {
          "bottomMenu": self.bottomMenuList,
          // 'noOfUsers': self.plan.no_user,
          // 'noOfBranch':self.plan.no_branch,
          // 'informToUser': self.plan.informToUser,
        }
        axios.post('users/profiles/update-direct-candidate-plan-permissions/'+self.editId, postData)
            .then((response) => {
              self.submitted = false; //Enable Button
              store.commit("showLoader", false);
              if (response.data.code === "200") {
                self.err_msg = response.data.message;
                localStorage.setItem("notificationType", "success");
                localStorage.setItem(
                    "notificationMessage",
                    response.data.message
                );
                self.messageColor = "success";
                this.$router.push({path: `/direct-candidates/view/${self.editId}`});
                self.dismissCountDown = 10;
                window.scrollTo(0, 0);
              } else {
                self.err_msg = response.data.message;
                self.messageColor = "danger";
                self.dismissCountDown = 10;
              }
            })
            .catch(function (error) {
              let data;
              if (error.response.data.error) {
                data = error.response.data.error.toString();
              } else {
                data = error.response.data.message;
              }
              self.err_msg = data;
              self.dismissCountDown = 10;
              self.submitted = false; //Enable Button
            });
      }, 500);
    },
    changePermission(index, val) {
      let self = this;
      var postData = {
        'id' : val.value
      };
      axios.post('plan/module/permission', postData).then((response) => {
        self.bottomMenuList[index].permission = [];
        self.bottomMenuList[index].permissionList = [];
        response.data.data.map(function (value, key) {
          self.bottomMenuList[index].permissionList.push({value: value.id, label: value.title});
        });
      });
    },
    addMenu() {
      this.bottomMenuList.push({
        id: `${++this.menuCounter}`,
        selected: '',
        permission: [],
        permissionList: [],
      });
    },
    setAlert(value) {
      this.showAlert = value;
    },
  },
};
</script>
